import { render } from "./AccountTermsModal.vue?vue&type=template&id=ca34a2cc"
import script from "./AccountTermsModal.vue?vue&type=script&lang=ts"
export * from "./AccountTermsModal.vue?vue&type=script&lang=ts"
script.render = render

export default script